<div class="card border-0 shadow-sm">
    <div class="card-header text-light border-0 bg-secondary">
        Download App
    </div>
    <div class="card-body" style="min-height: 30vh;">
        <div class="card shadow p-1 border-warning">
            <ul class="list-group">
                <li class="list-group-item justify-content-between align-items-end">
                    <span>
                        <i class="fa-brands fa-apple me-2"></i>
                         Mac - Apple Silicon
                    </span>
                    <button type="button" class="btn btn-sm float-end" [ngClass]="{'btn-warning':isMac(), 'btn-light':!isMac()}" (click)="download('armdmg')" aria-label="Download for Mac Apple Silicon"><i class="fas fa-download" aria-hidden="true"></i></button>
                </li>
                <li class="list-group-item justify-content-between align-items-end">
                    <span>
                        <i class="fa-brands fa-apple me-2"></i>
                         Mac - Apple Intel
                    </span>
                    <button type="button" class="btn btn-sm float-end" [ngClass]="{'btn-warning':isMac(), 'btn-light':!isMac()}"  (click)="download('dmg')" aria-label="Download for Mac Apple Intel"><i class="fas fa-download" aria-hidden="true"></i></button>
                </li>
                <li class="list-group-item justify-content-between align-items-end">
                    <span>
                        <i class="fa-brands fa-windows me-2"></i>
                        Windows
                    </span>
                    <button type="button" class="btn btn-sm float-end" [ngClass]="{'btn-warning':isWindows(), 'btn-light':!isWindows()}" (click)="download('exe')" aria-label="Download for Windows"><i class="fas fa-download" aria-hidden="true"></i></button>
                </li>
              </ul>
        </div>
    </div>


    <div class="card-footer border-0">
       <span class="float-end">
        <button class="btn btn-secondary btn-sm text-light" (click)="dialogRef.close()">
            Close
        </button>
       </span>
    </div>  
</div>